export const StatusDisplay = ({ isVerified, verifiedText }) => {
  return (
    <>
    {isVerified ? (
      <span style={{ color: 'green', marginLeft: '10px' }}>✓ {verifiedText}</span>
    ): (
      <span style={{ color: 'red', marginLeft: '10px' }}>Not {verifiedText}</span>
    )}
    </>
  )
}
